module.exports = __webpack_public_path__ + "img/1-1P62G20032W4.4d178b90.png";